import { useEffect } from 'react';
import { create } from 'zustand';

import { isAirportClient } from '~/config/airports.config';
import { readVenueLanguagePicker } from '~/services/playerLanguage/venueLanguagePicker';
import type { VenueLanguagePicker } from '~/utils/playerLanguage';

type VenueLanguagePickerState = {
    /** Réglage du lieu tel que lu par ce téléphone (`undefined` = pas encore lu / illisible). */
    venueAllows: VenueLanguagePicker;
};

/**
 * Partagé entre l'écran du pseudo, l'écran « Salut X » et les réglages en cours de
 * partie (qui vit sous <UnboaredGame>, loin de GamepadApp).
 */
export const useVenueLanguagePicker = create<VenueLanguagePickerState>(() => ({
    venueAllows: undefined,
}));

/**
 * Lit le réglage UNE fois par chargement de page (GamepadApp). Un téléphone déjà en
 * jeu quand l'établissement change l'option la verra au prochain rechargement ou scan.
 */
export function useLoadVenueLanguagePicker(clientID: string | null) {
    useEffect(() => {
        useVenueLanguagePicker.setState({ venueAllows: undefined });
        // Aéroport : le choix est toujours proposé, inutile de lire le réglage.
        if (!clientID || isAirportClient(clientID)) return undefined;
        let alive = true;
        readVenueLanguagePicker(clientID).then((venueAllows) => {
            if (alive) useVenueLanguagePicker.setState({ venueAllows });
        });
        return () => {
            alive = false;
        };
    }, [clientID]);
}
